// extracted by mini-css-extract-plugin
export default {"Menu_container":"Menu_Menu_container__1joW9","Menu":"Menu_Menu__BTYM1","Menu_items":"Menu_Menu_items__OZlbz"};